// packages/shared/api-client/endpoints/eboardUpdates.js
// E-Board updates API endpoints

import { baseApi } from "../baseApi";

/**
 * E-Board Update API endpoints
 * Provides E-Board monthly update submission and viewing
 */
const eboardUpdateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all eboard updates with filtering
    getEboardUpdates: builder.query({
      query: (params = {}) => ({
        url: '/api/eboard-updates',
        params, // { year?, month?, userId? }
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'EboardUpdate', id })),
              { type: 'EboardUpdate', id: 'LIST' },
            ]
          : [{ type: 'EboardUpdate', id: 'LIST' }],
    }),

    // Get specific eboard update by ID
    getEboardUpdateById: builder.query({
      query: (id) => `/api/eboard-updates/${id}`,
      providesTags: (result, error, id) => [{ type: 'EboardUpdate', id }],
    }),

    // Get summary of available years/months
    getEboardUpdatesSummary: builder.query({
      query: () => '/api/eboard-updates/summary',
      providesTags: [{ type: 'EboardUpdate', id: 'SUMMARY' }],
    }),

    // Create new eboard update
    createEboardUpdate: builder.mutation({
      query: (updateData) => ({
        url: '/api/eboard-updates',
        method: 'POST',
        body: updateData, // { year, month, updates, questionsAndConcerns, charityRequests }
      }),
      invalidatesTags: [
        { type: 'EboardUpdate', id: 'LIST' },
        { type: 'EboardUpdate', id: 'SUMMARY' },
      ],
    }),

    // Update eboard update
    updateEboardUpdate: builder.mutation({
      query: ({ id, ...updateData }) => ({
        url: `/api/eboard-updates/${id}`,
        method: 'PUT',
        body: updateData, // { updates?, questionsAndConcerns?, charityRequests? }
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'EboardUpdate', id },
        { type: 'EboardUpdate', id: 'LIST' },
      ],
    }),

    // Delete eboard update
    deleteEboardUpdate: builder.mutation({
      query: (id) => ({
        url: `/api/eboard-updates/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [
        { type: 'EboardUpdate', id: 'LIST' },
        { type: 'EboardUpdate', id: 'SUMMARY' },
      ],
    }),
  }),
});

// Export hooks for usage in components
export const useGetEboardUpdatesQuery = eboardUpdateApi.useGetEboardUpdatesQuery;
export const useGetEboardUpdateByIdQuery = eboardUpdateApi.useGetEboardUpdateByIdQuery;
export const useGetEboardUpdatesSummaryQuery = eboardUpdateApi.useGetEboardUpdatesSummaryQuery;
export const useCreateEboardUpdateMutation = eboardUpdateApi.useCreateEboardUpdateMutation;
export const useUpdateEboardUpdateMutation = eboardUpdateApi.useUpdateEboardUpdateMutation;
export const useDeleteEboardUpdateMutation = eboardUpdateApi.useDeleteEboardUpdateMutation;
